import styled from 'styled-components';

export const StyledArrowType1 = styled.div``;

export const StyledArrowType2 = styled.div`
  margin-bottom: -6px !important;
`;
